<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      :actions="actions"
      ref="grid"
      navigationPath="DedicationItemView"
      navigationField="dedicationItemID"
      :selectionEnabled="true"
    ></dx-grid>
    <v-dialog v-model="newItem.dialog" persistent max-width="800">
      <v-card class="px-4">
        <v-card-title>
          <span class="headline">Add Item</span>
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  label="Select Site *"
                  :items="buildings"
                  item-text="description"
                  item-value="code"
                  v-model="newItem.buildingCode"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field
                  label="Item Name *"
                  v-model="newItem.name"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-flex>

              <!-- Type -->
              <v-flex xs12 md6>
                <v-select
                  v-if="newItem.type != 'other'"
                  reverse
                  label="זכות *"
                  :items="getTypeListValue()"
                  v-model="newItem.type"
                  :rules="[rules.required]"
                  required
                  class="rtl"
                ></v-select>
                <v-text-field
                  v-else
                  label="זכות *"
                  v-model="newItem.customType"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-flex>

              <!-- Suggested Price -->
              <v-flex xs12 md6>
                <v-text-field
                  label="Suggested Price"
                  v-model.number="newItem.suggestedPrice"
                  type="number"
                  prefix="$"
                  :rules="[(v) => v >= 0 || 'Price must be positive']"
                ></v-text-field>
              </v-flex>

              <!-- Status -->
              <v-flex xs12 md6>
                <v-select
                  label="Status *"
                  :items="statusList"
                  v-model="newItem.status"
                ></v-select>
              </v-flex>

              <!-- Description -->
              <v-flex xs12>
                <v-textarea
                  label="Description"
                  v-model="newItem.description"
                  rows="3"
                  counter
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn dark @click="resetNewItemForm" color="default">
              Cancel
            </v-btn>
            <v-btn :loading="processing" dark @click="addItem" color="success">
              Add
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="zechusim.dialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-2"
          >רשימת הזכותים({{ typeList.length }})</v-card-title
        >
        <v-btn small color="success" dark @click="zechusim.addNew.dialog = true"
          >Add new zechus</v-btn
        >
        <v-btn
          small
          color="success"
          v-if="typeList.filter((m) => m.selected).length"
          @click="zechusim.delete.confirmDialog = true"
          >Delete selected
        </v-btn>
        <v-layout row justify-start>
          <div class="width-25 mr-2"></div>
          <div class="pt-1 font-weight-bold width-220">
            שם הזכות
          </div>
          <v-spacer></v-spacer>
        </v-layout>
        <v-divider class="my-2"></v-divider>
        <div style="overflow-y: auto; height: 400px">
          <div v-for="(zechus, index) in typeList">
            <v-layout row justify-start>
              <v-checkbox
                :id="(zechus.value, String(index))"
                v-model="zechus.selected"
                class="my-0 mr-2 width-25"
                color="success"
                hide-details
              ></v-checkbox>
              <label
                class="pt-1 width-220"
                :for="(zechus.value, String(index))"
                >{{ zechus.value }}</label
              >

              <v-spacer></v-spacer>
            </v-layout>
            <v-divider
              class="my-2"
              v-if="index + 1 < typeList.length"
            ></v-divider>
          </div>
        </div>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            dark
            @click="(zechusim.dialog = false), loadTypeList()"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="zechusim.addNew.dialog" max-width="350">
      <v-card class="pa-4">
        <v-form ref="addNewZechusForm">
          <v-layout row>
            <v-card-title class="headline pl-0 pt-0 pb-2"
              >New zechus</v-card-title
            >
          </v-layout>

          <v-text-field
            v-model="zechusim.addNew.name"
            label="שם הזכות"
            placeholder="לייג אריין א זכות"
            outlined
          />

          <v-card-actions class="mr-0 mt-3 ml-0 pb-0">
            <v-spacer></v-spacer>

            <v-btn color="default" dark @click="resetNewZechusForm()"
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              color="success"
              @click="saveNewZechus()"
              :disabled="!zechusim.addNew.name"
            >
              Add
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      persistent
      v-model="zechusim.delete.confirmDialog"
      max-width="400"
    >
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Delete zechusim</v-card-title>

        <div class="font-weight-medium">
          The
          {{ typeList.filter((m) => m.selected).length }}
          selected zechusim will be deleted
        </div>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            dark
            @click="zechusim.delete.confirmDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="deleteZechusim()"
          >
            delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="deleteItemDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Delete item(s)</v-card-title>

        <div class="font-weight-medium">
          The selected item(s) will be deleted
        </div>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteItemDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="deleteItems()">
            delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { formatCurrency } from "../../utils/helpers.js";
import { truncate, onlyUnique } from "../../utils/helpers.js";
import { loadOptions } from "../../utils/smLookup.js";
export default {
  data: () => ({
    // cancelBtnAbility: false,
    // sendBtnDisability: false,
    title: "Dedication Items",
    url: "",
    actions: [],
    processing: false,
    // uploading: false,
    newItem: {
      dialog: false,
      buildingCode: "",
      name: "",
      type: "",
      customType: "",
      suggestedPrice: "",
      status: "Available",
      description: "",
    },
    zechusim: {
      dialog: false,
      selected: [],
      addNew: {
        dialog: false,
        name: "",
      },
      delete: {
        dialog: false,
        confirmDialog: false,
      },
    },
    buildings: [],
    statusList: [],
    typeList: [],
    deleteItemDialog: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    columns: [
      {
        label: "ID",
        field: "dedicationItemID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-70",
        link: "DedicationItemView",
        template: "link-cell-template",
      },
      {
        label: "Building Code",
        field: "buildingCode",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-100",
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-300",
      },
      {
        label: "Type",
        field: "type",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200",
      },
      {
        label: "Suggested Price",
        field: "suggestedPrice",
        format: {
          type: "currency",
          precision: 2,
        },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-100",
      },
      {
        label: "Status",
        field: "status",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-150",
      },
      {
        label: "Description",
        field: "description",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-300",
      },
      {
        label: "Created On",
        field: "createdOn",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200",
      },
      {
        label: "Created By",
        field: "createdBy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200",
      },
      {
        label: "Status Changed On",
        field: "statusChangedOn",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200",
      },
      {
        label: "Status Changed By",
        field: "statusChangedBy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200",
      },
    ],
  }),
  watch: {},
  async created() {
    this.actions.push({
      text: "Delete selected Item(s)",
      action: this.opemDeleteItemDialog,
      showOnSelection: true,
    });
    this.actions.push({
      text: "זכותים",
      action: this.openZechusimDialog,
    });
    this.actions.push({
      text: "Create New Item",
      action: this.openNewItemDialog,
    });

    this.getBuildings();
    this.loadStatusList();
    await this.loadTypeList();

    if (this.$route.query.openNewItem) {
      this.openNewItemDialog();
    }
  },

  methods: {
    async beforeSetupGrid() {
      this.url = "dedicationitems";
    },

    isAdmin() {
      const isAdmin = this.$store.getters["authentication/isAdmin"];
      if (!isAdmin || isAdmin == "false") return false;

      return true;
    },
    openNewItemDialog() {
      this.newItem.dialog = true;
    },

    resetNewItemForm() {
      this.newItem = {
        dialog: false,
        buildingCode: "",
        name: "",
        type: "",
        customType: "",
        suggestedPrice: null,
        status: "Available",
        description: "",
      };
      this.$refs.form.resetValidation(true);
      this.processing = false;
    },

    async addItem() {
      if (!this.$refs.form.validate(true)) {
        return;
      }
      this.processing = true;
      try {
        const payload = {
          BuildingCode: this.newItem.buildingCode,
          Name: this.newItem.name,
          Type: this.newItem.customType
            ? this.newItem.customType
            : this.newItem.type,
          SuggestedPrice: this.newItem.suggestedPrice || 0,
          Status: this.newItem.status,
          Description: this.newItem.description || "",
          User: this.$store.state.authentication.user.toLowerCase(),
        };

        const response = await this.$http.post(
          "api/dedicationitems/CreateItem",
          payload
        );
        this.processing = false;
        this.$notify({
          text: "Item added successfully!",
          group: "notification",
          type: "success",
        });
        this.$refs.grid.reloadGrid();
        this.resetNewItemForm();
      } catch (error) {
        this.processing = false;
        this.$notify({
          text: "Failed to add item. Please try again.",
          group: "notification",
          type: "error",
        });
      }
    },

    async getBuildings() {
      try {
        const response = await this.$http.get(
          `api/dedicationitems/getBuildings`
        );
        this.buildings = response;
      } catch (error) {}
    },
    async loadStatusList() {
      var options = await loadOptions("DedicationItemStatus");
      this.statusList = options
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((c) => c.value);
    },

    async loadTypeList() {
      var options = await loadOptions("DedicationItemType");
      const result = options
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((c) => {
          c.selected = false;
          return c;
        });
      this.typeList = result;
    },

    openZechusimDialog() {
      this.zechusim.dialog = true;
    },
    resetNewZechusForm() {
      this.zechusim.addNew.dialog = false;
      this.zechusim.addNew.name = "";
    },
    async saveNewZechus() {
      try {
        this.processing = true;
        await this.$http.post("api/smLookup/save", [
          {
            type: "DedicationItemType",
            value: this.zechusim.addNew.name,
            sortOrder: "",
          },
        ]);

        this.processing = false;

        this.$notify({
          text: "Zechus added successfully!",
          group: "notification",
          type: "success",
        });
        this.loadTypeList();
        this.resetNewZechusForm();
      } catch (error) {
        this.processing = false;
        this.$notify({
          text: "Failed to add zechus. Please try again.",
          group: "notification",
          type: "error",
        });
      }
    },
    async deleteZechusim() {
      var selectedZechusimIds = [];
      try {
        this.typeList.map((a) => {
          if (a.selected) {
            selectedZechusimIds.push(a.id);
          }
        });
        this.processing = true;
        await this.$http.post("api/smLookup/delete", selectedZechusimIds);
        this.$notify({
          text: "Zechus/im deleted successfully!",
          group: "notification",
          type: "success",
        });
      } catch (error) {
      } finally {
        selectedZechusimIds = "";
        this.processing = false;
        this.resetDelete();
      }
    },
    async resetDelete() {
      await this.loadTypeList();
      this.zechusim.delete = {
        dialog: false,
        confirmDialog: false,
      };
    },
    getTypeListValue() {
      const typeValue = this.typeList.map((i) => i.value);
      typeValue.push("other");
      return typeValue;
    },
    openConfirmDeletezechusimDialog() {},
    opemDeleteItemDialog() {
      this.deleteItemDialog = true;
    },
    async deleteItems() {
      const selected = this.$refs.grid.getSelectedRowsData();
      const selectedIds = selected.map((i) => i.dedicationItemID);
      this.processing = true;
      try {
        const response = await this.$http.post(
          "api/dedicationitems/DeleteItems",
          selectedIds
        );
        this.$refs.grid.reloadGrid();
        this.$notify({
          text: "Item(s) deleted successfully.",
          group: "notification",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          text: "Failed to delete item. Please try again.",
          group: "notification",
          type: "error",
        });
      } finally {
        this.processing = false;
        this.deleteItemDialog = false;
      }
    },
  },
};
</script>
<style scoped>
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1.5s infinite;
}
</style>
